<template>
  <div class="verification-list">
    <el-card shadow="hover" class="search-card">
      <el-form :inline="true" :model="searchForm" @submit.native.prevent="handleSearch">
        <el-form-item label="关键词">
          <el-input
              v-model="searchForm.keyword"
              placeholder="姓名/用户号码"
              clearable
              style="width: 200px"
              @keyup.enter.native="handleSearch"
          ></el-input>
        </el-form-item>
        <el-form-item label="认证状态">
          <el-select v-model="searchForm.verifyStatus" placeholder="全部" clearable style="width: 130px">
            <el-option label="待审核" :value="0"></el-option>
            <el-option label="已认证" :value="1"></el-option>
            <el-option label="未通过" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card shadow="hover" class="table-card">
      <el-table :data="tableData" v-loading="loading" stripe border>
<!--        <el-table-column prop="id" label="记录ID" width="90" align="center"></el-table-column>-->
        <el-table-column prop="userId" label="用户ID" width="90" align="center"></el-table-column>
        <el-table-column prop="realName" label="姓名" min-width="120"></el-table-column>
        <el-table-column prop="phone" label="用户号码" min-width="120"></el-table-column>
        <el-table-column prop="idCardNo" label="身份证号" min-width="180"></el-table-column>
        <!-- 所属街道 -->
        <el-table-column label="所属街道" min-width="130">
          <template slot-scope="{ row }">
            {{ getDistrictByCommunity(row.communityId) }}
          </template>
        </el-table-column>
        <!-- 所属社区 -->
        <el-table-column label="所属社区" min-width="150">
          <template slot-scope="{ row }">
            {{ getCommunityName(row.communityId) || row.communityName || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="类型" width="110">
          <template slot-scope="{ row }">
            <el-tag :type="personTypeTagType(row.personType)" size="small">
              {{ row.personType || '-' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="过期时间" width="170">
          <template slot-scope="{ row }">
            <span :class="{ 'expired-text': isExpired(row.expireAt) }">
              {{ row.expireAt || '-' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="认证状态" width="100" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="statusType(row.verifyStatus)" size="small">
              {{ statusText(row.verifyStatus) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="rejectReason" label="驳回原因" min-width="150" show-overflow-tooltip></el-table-column>
        <el-table-column label="提交时间" width="170">
          <template slot-scope="{ row }">
            {{ formatTime(row.createdAt) }}
          </template>
        </el-table-column>
        <el-table-column label="知情同意书" width="100" align="center">
          <template slot-scope="{ row }">
            <el-image
                v-if="row.attachment"
                :src="row.attachment"
                :preview-src-list="[row.attachment]"
                style="width: 40px; height: 40px; border-radius: 4px;"
                fit="cover"
            >
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline" style="font-size: 20px; color: #c0c4cc;"></i>
              </div>
            </el-image>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="130" fixed="right">
          <template slot-scope="{ row }">
            <div class="action-btns">
              <div class="action-row" v-if="row.verifyStatus === 0">
                <el-button size="mini" type="success" @click="handleApprove(row)">通过</el-button>
                <el-button size="mini" type="danger" @click="handleReject(row)">驳回</el-button>
              </div>
              <div class="action-row" v-if="row.verifyStatus === 1">
                <el-button size="mini" type="primary" @click="openEdit(row)">修改</el-button>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 50]"
          :page-size="size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          class="pagination"
      ></el-pagination>
    </el-card>

    <!-- 驳回原因弹窗 -->
    <el-dialog title="驳回认证" :visible.sync="rejectVisible" width="400px">
      <el-form>
        <el-form-item label="驳回原因" required>
          <el-input v-model="rejectReason" type="textarea" :rows="3" placeholder="请输入驳回原因"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="rejectVisible = false">取 消</el-button>
        <el-button type="danger" :loading="submitting" @click="doReject">确 定</el-button>
      </div>
    </el-dialog>


    <!-- 修改类型和过期时间 + 所属社区 -->
    <el-dialog title="修改认证信息" :visible.sync="editVisible" width="520px">
      <el-form label-width="100px">
        <el-form-item label="人群类型" required>
          <el-select v-model="editForm.personType" placeholder="请选择" style="width: 100%">
            <el-option
                v-for="item in personTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="过期时间" required>
          <el-date-picker
              v-model="editForm.expireAt"
              type="datetime"
              placeholder="选择日期时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="{
          disabledDate(time) {
            return time.getTime() < Date.now() - 8.64e7
          }
        }"
              style="width: 100%"
          />
        </el-form-item>
        <!-- 所属街道 -->
        <el-form-item label="所属街道" required>
          <el-select
              v-model="editForm.district"
              placeholder="请选择街道"
              filterable
              style="width:100%"
              @change="handleEditDistrictChange"
          >
            <el-option v-for="d in districtList" :key="d" :label="d" :value="d"></el-option>
          </el-select>
        </el-form-item>
        <!-- 所属社区 -->
        <el-form-item label="所属社区" required>
          <el-select
              v-model="editForm.communityId"
              placeholder="请选择社区"
              filterable
              style="width:100%"
          >
            <el-option
                v-for="c in editFilteredCommunities"
                :key="c.id"
                :label="c.name"
                :value="c.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="editVisible = false">取 消</el-button>
        <el-button type="primary" :loading="editSubmitting" @click="doEdit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getVerificationList, approveVerification, rejectVerification ,updateVerification, getPersonTypeList} from '@/api/user'
import { getCommunityNameList } from '@/api/community'
// 字典接口不可用时的兜底列表，保证编辑功能不受影响
const FALLBACK_PERSON_TYPES = [
  { code: 'TEKU', label: '特困', tagType: 'danger', sort: 0 },
  { code: 'DIBAO_DIBIAN', label: '低保低边', tagType: 'warning', sort: 1 },
  { code: 'DIBAO_BIANYUANHU', label: '低保边缘户', tagType: 'warning', sort: 2 },
  { code: 'CANZHANG', label: '残障人士', tagType: 'info', sort: 3 },
  { code: 'GAOLING_DUJU', label: '高龄独居', tagType: 'success', sort: 4 },
  { code: 'XINJIUYE', label: '新就业群体', tagType: 'primary', sort: 5 },
  { code: 'OTHER', label: '其他', tagType: '', sort: 6 }
]
export default {
  name: 'VerificationList',
  data() {
    return {
      searchForm: { keyword: '',verifyStatus: '' },
      tableData: [],
      loading: false,
      page: 1,
      size: 10,
      total: 0,
      rejectVisible: false,
      rejectReason: '',
      currentRow: null,
      submitting: false,
      editVisible: false,
      editSubmitting: false,
      editForm: {
        id: null,
        personType: '',
        expireAt: '',
        district: '',
        communityId: null
      },
      // 由 /personTypes/list 动态填充，不再硬编码
      personTypeOptions: [],
      // label -> tagType，供表格 tag 取色
      personTypeMap: {},
      // 社区相关数据
      communities: [],
      districtList: []
    }
  },

  computed: {
    // 弹窗内：根据所选街道过滤社区列表
    editFilteredCommunities() {
      if (!this.editForm.district) return this.communities
      return this.communities.filter(c => c.district === this.editForm.district)
    }
  },

  mounted() {
    this.loadCommunities()
    this.loadPersonTypes()
    this.loadData()
  },

  methods: {
    /* ========== 社区数据加载 ========== */
    async loadCommunities() {
      try {
        const res = await getCommunityNameList()
        const list = res.records || res.list || res.items || res || []
        this.communities = Array.isArray(list) ? list : []
        this.districtList = [...new Set(this.communities.map(c => c.district).filter(Boolean))]
      } catch (e) {}
    },

    /* ========== 人群类型字典加载（/personTypes/list）========== */
    async loadPersonTypes() {
      try {
        const res = await getPersonTypeList()
        // 兼容 R<T> 包装与裸数组两种返回结构
        const raw = res && res.data != null ? res.data : res
        const list = (raw && (raw.records || raw.list || raw.items)) || raw || []
        if (!Array.isArray(list) || !list.length) {
          throw new Error('empty')
        }
        // 后端 sort 可能缺省，按数组下标兜底，保证展示顺序稳定
        const sorted = [...list].sort(
            (a, b) => (a.sort == null ? 0 : a.sort) - (b.sort == null ? 0 : b.sort)
        )
        this.personTypeOptions = sorted
            .filter(i => i && i.label)
            .map(i => ({ label: i.label, value: i.label, code: i.code }))
        this.personTypeMap = sorted.reduce((m, i) => {
          if (i && i.label) m[i.label] = i.tagType || ''
          return m
        }, {})
      } catch (e) {
        // 接口异常时降级，避免下拉框为空导致无法编辑
        this.personTypeOptions = FALLBACK_PERSON_TYPES.map(i => ({
          label: i.label,
          value: i.label,
          code: i.code
        }))
        this.personTypeMap = FALLBACK_PERSON_TYPES.reduce((m, i) => {
          m[i.label] = i.tagType
          return m
        }, {})
      }
    },


    /* ========== 弹窗内街道切换 ========== */
    handleEditDistrictChange() {
      this.editForm.communityId = null
    },

    /* ========== 工具方法（同 StaffList） ========== */
    getCommunityName(id) {
      if (id == null) return '-'
      const c = this.communities.find(x => x.id === id)
      return c ? c.name : '-'
    },

    getDistrictByCommunity(id) {
      if (id == null) return '-'
      const c = this.communities.find(x => x.id === id)
      return c ? c.district : '-'
    },

    /* ========== 表格数据加载 ========== */
    async loadData() {
      this.loading = true
      try {
        const res = await getVerificationList(this.searchForm.keyword, this.searchForm.verifyStatus, this.page, this.size)
        const list = res.records || res.list || res.items || res || []
        this.tableData = Array.isArray(list) ? list : []
        this.total = res.total || this.tableData.length
      } catch (e) {
        this.tableData = []
        this.total = 0
      } finally {
        this.loading = false
      }
    },
    handleSearch() { this.page = 1; this.loadData() },
    resetSearch() { this.searchForm = { verifyStatus: '' }; this.page = 1; this.loadData() },
    handleSizeChange(val) { this.size = val; this.loadData() },
    handleCurrentChange(val) { this.page = val; this.loadData() },
    statusType(s) { return s === 0 ? 'warning' : s === 1 ? 'success' : 'danger' },
    statusText(s) { return s === 0 ? '待审核' : s === 1 ? '已认证' : '未通过' },
    async handleApprove(row) {
      try {
        await approveVerification(row.id)
        this.$message.success('已通过认证')
        this.loadData()
      } catch (e) {}
    },
    handleReject(row) { this.currentRow = row; this.rejectReason = ''; this.rejectVisible = true },
    async doReject() {
      if (!this.rejectReason.trim()) return this.$message.warning('请输入驳回原因')
      this.submitting = true
      try {
        await rejectVerification(this.currentRow.id, this.rejectReason)
        this.$message.success('已驳回')
        this.rejectVisible = false
        this.loadData()
      } catch (e) {} finally {
        this.submitting = false
      }
    },
    formatTime(t) { return t ? new Date(t).toLocaleString('zh-CN', { hour12: false }) : '-' },

    // 人群类型 tag 颜色：取自 /personTypes/list，未命中时不取色
    personTypeTagType(type) {
      if (!type) return ''
      return this.personTypeMap[type] || ''
    },

    // 是否过期
    isExpired(expireAt) {
      if (!expireAt) return false
      return new Date(expireAt).getTime() < Date.now()
    },

    /* ========== 修改弹窗 ========== */
    openEdit(row) {
      // 尝试从 communities 中匹配该行的社区信息
      const com = this.communities.find(x => x.id === row.communityId)
      this.editForm = {
        id: row.id,
        personType: row.personType || '',
        expireAt: row.expireAt || '',
        district: com ? com.district : '',
        communityId: row.communityId || null
      }
      this.editVisible = true
    },

    async doEdit() {
      if (!this.editForm.personType) {
        return this.$message.warning('请选择人群类型')
      }
      if (!this.editForm.expireAt) {
        return this.$message.warning('请选择过期时间')
      }
      if (!this.editForm.communityId) {
        return this.$message.warning('请选择所属社区')
      }

      // 根据 communityId 查找 communityName
      const selectedCom = this.communities.find(x => x.id === this.editForm.communityId)
      const communityName = selectedCom ? selectedCom.name : ''

      this.editSubmitting = true
      try {
        await updateVerification({
          id: this.editForm.id,
          personType: this.editForm.personType,
          expireAt: this.editForm.expireAt,
          communityId: this.editForm.communityId,
          communityName: communityName
        })
        this.$message.success('修改成功')
        this.editVisible = false
        this.loadData()
      } catch (e) {
        // 错误已由拦截器处理
      } finally {
        this.editSubmitting = false
      }
    }
  }
}
</script>

<style scoped>
.verification-list { padding: 0; }
.search-card { margin-bottom: 16px; border-radius: 8px; }
.table-card { border-radius: 8px; }
.pagination { margin-top: 16px; text-align: right; }
.expired-text {
  color: #f56c6c;
  font-weight: bold;
}
.action-btns {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}
.action-row {
  display: flex;
  justify-content: center;
  gap: 6px;
}
.action-row .el-button + .el-button {
  margin-left: 0;
}
</style>
